export default __webpack_public_path__ + "media/images/foxes-full-logo-c360dcf8503fdd29ba59761cb6a0b2db.png";